export const environment = {
  production: false,
  staging: true,
  apiGateway: "https://api.doneapp.tec.br",
  doneWorkspaceApp: "https://workspace.doneapp.tec.br",
  donePointerApp: "https://pointer.doneapp.tec.br/",

  appName: "Done! Pointer",

  appCode: "1050"
};
